import * as _ from 'lodash'
import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions,
    IBusinessObjectCreateLoadOptions
} from "../PA.Core/PA.Core.IF.BO";
import { IEntitySource, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    WB_AutomationFlowRow,
    WB_CustomerRow,
    WB_FinishedProductRow, WB_PeriodRow,
    WB_ProductGroupRow,
    WB_Published_ModelRow, WB_ScenarioConstraintRow, WB_ScenarioPlannerConstraintRow,
    WB_ScenarioPlannerCustomerRow,
    WB_ScenarioPlannerEventTypeRow, WB_ScenarioPlannerPeriodPartitionRow,
    WB_ScenarioPlannerProductPartitionRelRow,
    WB_ScenarioPlannerProductPartitionRow,
    WB_ScenarioPlannerProductRow, WB_ScenarioPlannerPromotionRelRow,
    WB_ScenarioPlannerRow, WB_ScenarioPlannerTrialPRRow, WB_ScenarioPlannerTrialRow,
    WB_ScenarioPlanRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbScenarioPlan } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Automation_Flow,
    esWB_Customer,
    esWB_Entity,
    esWB_MasterData_Set,
    esWB_Model,
    esWB_Period,
    esWB_Product_Group,
    esWB_Published_Model,
    esWB_SalesOrg,
    esWB_ScnConstraint,
    esWB_ScnPlan,
    esWB_ScnPlan_CustR,
    esWB_ScnPlan_PrdR,
    esWB_ScnPlanner,
    esWB_ScnPlannerCalc,
    esWB_ScnPlannerCnstr,
    esWB_ScnPlannerCR,
    esWB_ScnPlannerESR,
    esWB_ScnPlannerPPR,
    esWB_ScnPlannerPR,
    esWB_ScnPlannerPrdPPR,
    esWB_ScnPlannerPrdPR,
    esWB_ScnPlannerPrmR,
    esWB_ScnPlannerTrial,
    esWB_ScnPlannerTrialCNR,
    esWB_ScnPlannerTrialEvt,
    esWB_ScnPlannerTrialPR
} from '../PA.Core/PAdbSchema'
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";

import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { BehaviorSubject } from "rxjs";
import { CoefficientSetUtils, ICoefficientSetSubModel } from "../PA.Model.Core/CoefficientSetUtils";
import { EntityTypeUtils } from "../PA.MD.Entity/EntityTypeUtils";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection"
import { ErrorMessage_restate, ExceptionMessage_restate, InfoMessage_restate } from "../PA.Core/Basic/MessageUtils";
import { ConstraintBasedOptimizerBO, ICBOCreateLoadOptions } from "./ConstraintBasedOptimizerBO";
import { ExecutionSerializer } from "../PA.Core/Basic/ExecutionSerializer";
import { PASearch } from "../PA.Core/PASearch";
import {FlowEditorUtils} from "../PA.Automation.Core/FlowEditorUtils";

//const arrSIMULATION_INPUT_IDs = ['GROSSLISTPRICE', 'LISTPRICE', 'VCM', 'COGS']
//const arrSIMULATION_INPUT_TYPE_IDs = ['GrossListPrice', 'ListPrice', 'VCM', 'COGS']
const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));

export interface IAvailablePromotionEvent {
    Row: WB_ScenarioPlannerPromotionRelRow,
    PropertyChanged: string,
    PropertyValue: string
}

export class ScenarioPlannerBO implements IBusinessObject {
    Identity: IdentityProvider

    CreateOptions: any

    LoadOptions: IBusinessObjectCreateLoadOptions
    _bIsLoaded: boolean
    _OnLoadComplete: Promise<IBusinessObject>
    LoadProgressProvider: IProgressProvider

    ValidateOptions: any
    _bIsValidated: boolean
    ValidateMessageProvider: IMessageProvider
    ValidateProgressProvider: IProgressProvider

    SaveOptions: any
    _bIsSaved: boolean
    SaveProgressProvider: IProgressProvider

    DeleteOptions: any
    _bIsDeleted: boolean
    DeleteMessageProvider: IMessageProvider
    DeleteProgressProvider: IProgressProvider

    dbContext: PAdbContext
    drWB_ScenarioPlanner: WB_ScenarioPlannerRow

    constructor(options?: any) {
        this.CreateOptions = options || {}

        if ('dbContext' in this.CreateOptions) this.dbContext = this.CreateOptions.dbContext

        this.Identity = new IdentityProvider({ id: 0, name: 'New Scenario' })

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._OnLoadComplete = undefined
        this.LoadProgressProvider = new ProgressProvider('Loading', this)

        this.ValidateOptions = {}
        this._bIsValidated = false
        this.ValidateMessageProvider = new MessageProvider()
        this.ValidateProgressProvider = new ProgressProvider('Validating', this)

        this.SaveOptions = {}
        this._bIsSaved = false
        this.SaveProgressProvider = new ProgressProvider('Saving', this)

        this.DeleteOptions = {}
        this._bIsDeleted = false
        this.DeleteMessageProvider = new MessageProvider()
        this.DeleteProgressProvider = new ProgressProvider('Deleting', this)

        this.drWB_ScenarioPlanner = undefined

        this.IHaveSecurity_init()
        this.IScenarioPlanner_Scenario_Scope_init()
        this.IScenarioPlanner_Scope_init()
        this.IScenarioPlanner_TrialStructure_init()
        this.IScenarioPlanner_Partitions_init()
        this.IScenarioPlanner_Constraints_init()
        this.IScenarioPlanner_AvailablePromotions_init()
        this.CustomerProducts_init()
        this.IScenarioPlanner_Trial_init()
        this.Reload_init()
    }

    get WB_ScenarioPlanner(): WB_ScenarioPlannerRow {
        return this.drWB_ScenarioPlanner
    }

    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        const self = this

        self.LoadProgressProvider.start('Creating Scenario Planner')
        const rv = (self._OnLoadComplete = (async () => {
            self.LoadOptions = options || {}
            if ('dbContext' in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
            else self.dbContext = new PAdbContext()

            if (_.isEmpty(self.dbContext)) {
                const sError = 'Unable to determine dbContext for new Scenario Planner.'
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(sError)

                return self
            }
            try {
                // Create record using dbContext
                const plannerRow: WB_ScenarioPlannerRow = <WB_ScenarioPlannerRow>(
                    await self.dbContext.createRecordWithKey(esWB_ScnPlanner)
                )
                plannerRow.setDefaults()
                plannerRow.cif.PLANNER_NAME = self.LoadOptions.sName
                plannerRow.cif.WB_MDSET_ID = self.LoadOptions.wbMasterDataSetId || 0
                plannerRow.cif.WB_SALESORG_ID = self.LoadOptions.wbSalesOrgId || 0
                plannerRow.cif.WB_PUBLISHED_MODEL_ID = self.LoadOptions.wbPublishedModelId || 0
                plannerRow.cif.SINGLE_CUST_MODE_IND = '1'
                plannerRow.cif.EVENT_SUBTYPE_IND = '1'
                plannerRow.cif.PERIODPART_DURATION = 1

                await plannerRow.loadRelations([esWB_Published_Model, esWB_MasterData_Set, esWB_SalesOrg])
                if (!_.isEmpty(plannerRow.WB_PublishedModelRow)) {
                    await plannerRow.WB_PublishedModelRow.loadRelations([esWB_Model])
                    plannerRow.StartDt = plannerRow.WB_PublishedModelRow.EffectiveStartDt
                    plannerRow.EndDt = DateUtils.addDays(plannerRow.StartDt, 6)
                }

                self.drWB_ScenarioPlanner = plannerRow
                self.dbContext.add(esWB_ScnPlanner, plannerRow)
                self.Identity.setAll(
                    self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID,
                    self.WB_ScenarioPlanner.cif.PLANNER_ID,
                    self.WB_ScenarioPlanner.cif.PLANNER_NAME
                )
                self.Identity.listenToRecordUpdates(
                    self.WB_ScenarioPlanner,
                    'WB_SCNPLANNER_ID',
                    'PLANNER_ID',
                    'PLANNER_NAME'
                )
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlanner, 'PLANNER_ID', 'PLANNER_NAME')
                self.Identity.mdset = self.WB_ScenarioPlanner.cif.WB_MDSET_ID
                self.Identity.salesOrg = self.WB_ScenarioPlanner.cif.WB_SALESORG_ID
                self.Identity.createdBy = self.WB_ScenarioPlanner.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName('Loading ' + self.Identity.name + '(' + self.Identity.id_ui + ')')

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()

                return self
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }
        })())

        return rv
    }

    async Load(anId: number, options?: object): Promise<IBusinessObject> {
        const self = this

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start('Loading (' + anId + ')')

        const rv = (self._OnLoadComplete = (async () => {
            self.LoadProgressProvider.start('Loading (' + self.Identity.id_ui + ')')

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception('Scenario Plan already loaded.')
                self._OnLoadComplete = undefined
                return self
            }

            self.LoadOptions = options || {}

            try {
                if ('dbContext' in self.LoadOptions) self.dbContext = self.LoadOptions.dbContext
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({})
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception('Unable to determine dbContext for Scenario Plan.')
                    return self
                }

                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = ScenarioPlannerBO.createRecordResolver({ dbContext: self.dbContext })
                    recordResolverLoadPromise = ScenarioPlannerBO.setupRecordResolver(recordResolver, [anId])
                }

                await recordResolverLoadPromise
                const aPlanRow: any = recordResolver.get(esWB_ScnPlanner, anId)

                if (_.isEmpty(aPlanRow)) {
                    throw 'Scenario Planner not found'
                }

                self.drWB_ScenarioPlanner = aPlanRow
                self.Identity.setAll(
                    self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID,
                    self.WB_ScenarioPlanner.cif.PLANNER_ID,
                    self.WB_ScenarioPlanner.cif.PLANNER_NAME
                )
                self.Identity.listenToRecordUpdates(
                    self.WB_ScenarioPlanner,
                    'WB_SCNPLANNER_ID',
                    'PLANNER_ID',
                    'PLANNER_NAME'
                )
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlanner, 'PLANNER_ID', 'PLANNER_NAME')
                self.Identity.mdset = self.WB_ScenarioPlanner.cif.WB_MDSET_ID
                self.Identity.salesOrg = self.WB_ScenarioPlanner.cif.WB_SALESORG_ID
                self.Identity.createdBy = self.WB_ScenarioPlanner.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName('Loading ' + self.Identity.name + '(' + self.Identity.id_ui + ')')

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.finish()

                return self
            } catch (err) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                throw err
            }
        })())

        return rv
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded
    }

    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this

        self.ValidateMessageProvider.clearMessages()
        self.ValidateProgressProvider.start(
            'Validating ' + self.WB_ScenarioPlanner.cif.MDSET_NAME + '(' + self.WB_ScenarioPlanner.cif.MDSET_ID + ')'
        )

        self.ValidateOptions = options || {}
        try {
            if (_.isEmpty(self.dbContext)) {
                const sError = 'Unable to determine dbContext for to Validate Scenario Planner.'
                self.ValidateProgressProvider.exception(sError)
                return self
            }

            self._bIsValidated = self.ValidateMessageProvider.countMessages(MessageType.Error) == 0
            self.ValidateProgressProvider.finish()
        } catch (err) {
            self.ValidateMessageProvider.addMessage({
                code: 'Exception',
                type: MessageType.Error,
                description: JSON.stringify(err),
                title: 'Validation Exception'
            })
            self._bIsValidated = false
            self.ValidateProgressProvider.exception(err)
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this

        self._bIsSaved = false
        const wbScenarioPlan = <IwbScenarioPlan>self.drWB_ScenarioPlanner
        self.SaveProgressProvider.start('Saving ' + wbScenarioPlan.PLAN_NAME + '(' + wbScenarioPlan.PLAN_ID + ')')
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                const sError = 'Unable to determine dbContext to Save Scenario Plan.'
                self.SaveProgressProvider.exception(sError)
                return self
            }
            self.SaveOptions = options || {}

            await self.Validate(options)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.SaveProgressProvider.finish()
                return self
            }

            let saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any
            ) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_ScnPlanner, self.drWB_ScenarioPlanner, {})

            const tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_Automation_Flow, self.drWB_ScenarioPlanner.WB_AutomationFlowRow))
            tasks.push(saveFunction(esWB_ScnPlannerESR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerEventTypeRows))
            tasks.push(saveFunction(esWB_ScnPlannerCR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows))
            tasks.push(saveFunction(esWB_ScnPlannerPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductRows))
            tasks.push(
                saveFunction(esWB_ScnPlannerPPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerPeriodPartitionRows)
            )
            tasks.push(
                saveFunction(esWB_ScnPlannerPrdPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows)
            )
            tasks.push(
                saveFunction(
                    esWB_ScnPlannerPrdPPR,
                    _.flatMap(
                        self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows,
                        (a) => a.WB_ScenarioPlannerProductPartitionRelRows
                    )
                )
            )
            tasks.push(saveFunction(esWB_ScnPlannerCnstr, self.drWB_ScenarioPlanner.WB_ScenarioPlannerConstraintRows))
            tasks.push(saveFunction(esWB_ScnPlannerPrmR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerPromotionRelRows))
            tasks.push(saveFunction(esWB_ScnPlannerTrial, self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows))
            tasks.push(
                saveFunction(
                    esWB_ScnPlannerTrialPR,
                    _.flatMap(
                        self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows,
                        (a) => a.WB_ScenarioPlannerTrialPRRows
                    )
                )
            )
            tasks.push(
                saveFunction(
                    esWB_ScnPlannerTrialCNR,
                    _.flatMap(
                        self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows,
                        (a) => a.WB_ScenarioPlannerTrialCNRRows
                    )
                )
            )
            tasks.push(
                saveFunction(esWB_ScnPlannerTrialEvt, self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialEventRows)
            )
            if (!_.isEmpty(self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRow)) {
                tasks.push(saveFunction(esWB_ScnPlannerTrial, self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRow))
                tasks.push(
                    saveFunction(
                        esWB_ScnPlannerTrialPR,
                        self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRow.WB_ScenarioPlannerTrialPRRows
                    )
                )
            }
            await Promise.all(tasks)

            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true
                })
            } else {
                self._bIsSaved = true
            }
            self.SaveProgressProvider.finish()
            return self
        } catch (err) {
            self.SaveProgressProvider.exception(err)
            return self
        }
    }

    get bIsSaved(): boolean {
        return this._bIsSaved
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this

        const scnPlan = <IwbScenarioPlan>self.drWB_ScenarioPlanner

        this.DeleteMessageProvider.clearMessages()
        this.DeleteProgressProvider.start('Deleting ' + scnPlan.PLAN_NAME + '(' + scnPlan.PLAN_ID + ')')

        try {
            // 1. Validate if we can delete the Scenario
            //await ScenarioPlanBOValidations.ValidateDelete(self)
            if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ScenarioPlanner.markDeleted()

            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true
                self.DeleteProgressProvider.finish()
                return self
            } else {
                self._bIsDeleted = true
                self.DeleteProgressProvider.finish()
                return self
            }
        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this

        self.LoadProgressProvider.setProgressMessage('ScenarioPlannerBO.PostLoad', 'Processing Loaded Data')

        await self.IHaveSecurity_OnLoadComplete()
        await self.IScenarioPlanner_Trial_onLoadComplete()
        await self.IScenarioPlanner_Flow_onLoadComplete()

        const tasks: Promise<any>[] = []
        tasks.push(self.CustomerProducts_OnLoadComplete())
        tasks.push(self.IScenarioPlanner_Partitions_onLoadComplete())
        tasks.push(self.IScenarioPlanner_AvailablePromotions_onLoadComplete())

        await Promise.all(tasks)

        await self.IScenarioPlanner_Scenario_Scope_onLoadComplete()

        return
    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection
    private _bIHaveSecurityLoaded: boolean
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    //private _Lock: ILock

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
        //this._Lock = undefined
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded.then((ignore) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aHasRolePolicy: PolicyHasRole
        this._OnIHaveSecurityLoaded = (async () => {
            const aBOis = new PolicyBOis(['Super_User', 'Application_User'], [])
            self._PolicyCollection.addPolicy('BOis', aBOis)
            aHasRolePolicy = new PolicyHasRole()
            await aHasRolePolicy.OnLoadComplete
            self._PolicyCollection.addPolicy('HasRole', aHasRolePolicy)
            this._bIHaveSecurityLoaded = true
            return self
        })()

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }

    //</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        const opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_ScenarioPlanner, opts)
    }

    //</editor-fold>

    //<editor-fold desc = "Add Remove Customer, Product operations">

    private _bHasProductGroups: boolean
    private _bHasProducts: boolean
    private _allCustomers: WB_CustomerRow[]
    private _allProductGroups: WB_ProductGroupRow[]
    private _allProducts: WB_FinishedProductRow[]
    private _subModels: ICoefficientSetSubModel[]
    private _onCustomersChanged: BehaviorSubject<ScenarioPlannerBO>
    private _onProductsChanged: BehaviorSubject<ScenarioPlannerBO>
    private custEntitySource: IEntitySource
    private prdEntitySource: IEntitySource
    private wbPublishedModelId_Loaded: number

    private CustomerProducts_init() {
        this._bHasProductGroups = false
        this._bHasProducts = false
        this._allCustomers = []
        this._allProductGroups = []
        this._allProducts = []
        this._onCustomersChanged = new BehaviorSubject<ScenarioPlannerBO>(undefined)
        this._onProductsChanged = new BehaviorSubject<ScenarioPlannerBO>(undefined)
        this._subModels = []
        this.wbPublishedModelId_Loaded = 0
    }

    private async CustomerProducts_OnLoadComplete(): Promise<void> {
        const self = this
        await self.CustomerProducts_checkPublishedModelComponents()
    }

    private async CustomerProducts_checkPublishedModelComponents(): Promise<void> {
        const self = this

        //
        if (_.isEmpty(this.WB_ScenarioPlanner?.WB_PublishedModelRow)) {
            // Reset things
            return
        }

        // Check if we already loaded this published model
        if (this.wbPublishedModelId_Loaded == this.WB_ScenarioPlanner?.WB_PublishedModelRow.cif.WB_PUBLISHED_MODEL_ID)
            return

        this.wbPublishedModelId_Loaded = this.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_PUBLISHED_MODEL_ID

        const prdEntity = await EntityTypeUtils.getEntityTypeRow(
            this.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_ENTITY_ID_PRODUCT
        )

        if (_.isEmpty(prdEntity)) return

        this._bHasProducts = prdEntity.cif.ENTITY_ID in { FinishedProduct: 0, ConsumerProduct: 1 }
        this._bHasProductGroups = !this._bHasProducts

        const wbCoefSetId = this.WB_ScenarioPlanner.WB_PublishedModelRow?.cif?.WB_MODEL_COEFF_SET_ID

        const a = await CoefficientSetUtils.getCoefficientSetMasterData(wbCoefSetId, this.dbContext, true)
        this._allCustomers = a.Customers || []
        this._allProducts = a.Products || []
        this._allProductGroups = a.ProductGroups || []
        this._subModels = a.SubModels

        this.custEntitySource = {
            get Entities() {
                return self.ScenarioCustomers
            },
            get Selected() {
                return self.Customers
            },
            keyFields: {
                id: 'WB_CUST_ID',
                id_ui: 'CUSTOMER_ID',
                name: 'CUSTOMER_NAME'
            },
            onChange: this.OnCustomersChanged,
            addSelection(id: number): Promise<void> {
                return <any>self.addCustomer(id)
            },
            removeSelection(id: number): Promise<void> {
                return self.removeCustomer(id)
            }
        }

        if (this._bHasProductGroups) {
            this.prdEntitySource = {
                get Entities() {
                    return self.ScenarioProductGroups
                },
                get Selected() {
                    return self.ProductGroups
                },
                keyFields: {
                    id: 'WB_PRDGRP_ID',
                    id_ui: 'PRODUCT_GROUP_ID',
                    name: 'PRODUCT_GROUP_NAME'
                },
                onChange: this.OnProductsChanged,
                addSelection(id: number): Promise<void> {
                    return <any>self.addProductGroup(id)
                },
                removeSelection(id: number): Promise<void> {
                    return self.removeProductGroup(id)
                }
            }
        }
    }

    get OnCustomersChanged(): BehaviorSubject<ScenarioPlannerBO> {
        return this._onCustomersChanged
    }

    get OnProductsChanged(): BehaviorSubject<ScenarioPlannerBO> {
        return this._onProductsChanged
    }

    get AllCustomers(): WB_CustomerRow[] {
        return this._allCustomers
    }

    get Customers(): WB_CustomerRow[] {
        return _.map(
            _.filter(this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_CustomerRow)
            }),
            (b) => b.WB_CustomerRow
        )
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(
            _.filter(this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_ProductGroupRow) && a.cif.WB_PRDGRP_ID > 0
            }),
            (b) => b.WB_ProductGroupRow
        )
    }

    get CustomerEntitySource(): IEntitySource {
        return this.custEntitySource
    }

    get ProductEntitySource(): IEntitySource {
        return this.prdEntitySource
    }

    async addCustomer(wbCustId: number): Promise<WB_ScenarioPlannerCustomerRow> {
        const self = this
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows) {
            if (!a.isActive) continue
            if (a.cif.WB_CUST_ID == wbCustId) return a
        }

        const cust = <WB_CustomerRow>await self.dbContext.find(esWB_Customer, wbCustId)
        if (_.isEmpty(cust)) return undefined

        const newRow = <WB_ScenarioPlannerCustomerRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerCR)
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.WB_CUST_ID = wbCustId
        newRow.WB_CustomerRow = cust
        self.dbContext.add(esWB_ScnPlannerCR, newRow)
        self.OnCustomersChanged.next(self)
        return newRow
    }

    async removeCustomer(wbCustId: number): Promise<void> {
        const self = this
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows) {
            if (!a.isActive) continue
            if (a.cif.WB_CUST_ID == wbCustId) a.markDeleted()
        }
        self.OnCustomersChanged.next(self)
    }

    async addProductGroup(wbPrdGrpId: number): Promise<WB_ScenarioPlannerProductRow> {
        const self = this
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows) {
            if (!a.isActive) continue
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId) return a
        }

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId)
        if (_.isEmpty(pg)) return undefined

        const newRow = <WB_ScenarioPlannerProductRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerPR)
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
        newRow.WB_ProductGroupRow = pg
        self.dbContext.add(esWB_ScnPlannerPR, newRow)
        self.OnProductsChanged.next(self)

        return newRow
    }

    async removeProductGroup(wbPrdGrpId: number): Promise<void> {
        const self = this
        //--
        if (!(wbPrdGrpId > 0)) return

        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows) {
            if (!a.isActive) continue
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId) a.markDeleted()
        }
        self.OnProductsChanged.next(self)
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Scenario Scope operations">

    private _onScenarioScopeLockChange: BehaviorSubject<void>
    private _scenarioMessages: MessageProvider
    private _scenarioProgress: ProgressProvider
    private _scenarioCustomers: WB_CustomerRow[]
    private _scenarioProductGroups: WB_ProductGroupRow[]

    private IScenarioPlanner_Scenario_Scope_init() {
        //--
        this._onScenarioScopeLockChange = new BehaviorSubject<void>(undefined)
        this._scenarioMessages = new MessageProvider()
        this._scenarioProgress = new ProgressProvider()
        this._scenarioCustomers = []
        this._scenarioProductGroups = []
    }

    private async IScenarioPlanner_Scenario_Scope_onLoadComplete(): Promise<void> {
        await this.loadScenario(this._scenarioMessages)
    }

    get OnScenarioScopeLockChanged(): BehaviorSubject<void> {
        return this._onScenarioScopeLockChange
    }

    get bScenarioLocked(): boolean {
        return this.WB_ScenarioPlanner.bScenarioLocked
    }

    set bScenarioLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }

    get ScenarioMessages(): MessageProvider {
        return this._scenarioMessages
    }

    get ScenarioProgress(): ProgressProvider {
        return this._scenarioProgress
    }

    get ScenarioCustomers(): WB_CustomerRow[] {
        return this._scenarioCustomers
    }

    get ScenarioProductGroups(): WB_ProductGroupRow[] {
        return this._scenarioProductGroups
    }

    async unlockScenario(): Promise<void> {
        //
        let mp = this._scenarioMessages
        let pp = this._scenarioProgress
        pp.start()
        mp.clearMessages()

        // Validate if you can unlock

        InfoMessage_restate(mp, true, 'Unlocked', 'Scenario Unlocked')
        this.WB_ScenarioPlanner.bScenarioLocked = false
        this._onScenarioScopeLockChange.next()
        pp.finish()
    }

    async validateAndLockScenario(): Promise<void> {
        // Load Published Model, etc, etc
        //--
        let mp = this._scenarioMessages
        let pp = this._scenarioProgress
        pp.start()
        mp.clearMessages()

        if (!(this.WB_ScenarioPlanner.cif.WB_SCNPLAN_ID > 0)) {
            ErrorMessage_restate(mp, true, 'Not Set', 'Scenario Plan not set')
            pp.finish()
            return
        }

        // Load Scenario
        await this.loadScenario(mp)

        InfoMessage_restate(mp, true, 'Locked', 'Scenario Locked')
        this.WB_ScenarioPlanner.bScenarioLocked = true
        this._onScenarioScopeLockChange.next()
        pp.finish()
    }

    private async loadScenario(mp: MessageProvider): Promise<void> {
        const self = this
        const scnPlnrRow = self.WB_ScenarioPlanner
        const scnPlnr = self.WB_ScenarioPlanner.cif

        if (!(scnPlnr.WB_SCNPLAN_ID > 0)) {
            ErrorMessage_restate(mp, true, 'Not Set', 'Scenario Plan not set')
            return
        }

        let scnPlanRow = <WB_ScenarioPlanRow>await self.dbContext.find(esWB_ScnPlan, scnPlnr.WB_SCNPLAN_ID)

        if (_.isEmpty(scnPlanRow) || !scnPlanRow?.isActive) {
            ErrorMessage_restate(mp, true, 'Not Set', `Scenario Plan (${scnPlnr.WB_SCNPLAN_ID}) not found`)
            return
        }

        await scnPlanRow.loadRelations([esWB_Published_Model, esWB_ScnPlan_CustR, esWB_ScnPlan_PrdR])
        let pblshModelRow = <WB_Published_ModelRow>scnPlanRow.WB_PublishedModelRow

        let wbCustIds = _.map(
            _.filter(scnPlanRow.WB_ScenarioPlanCustomerRows, (a) => a.isActive && a.cif.WB_CUST_ID > 0),
            (b) => b.cif.WB_CUST_ID
        )
        let wbPrdGrpIds = _.map(
            _.filter(scnPlanRow.WB_ScenarioPlanProductRows, (a) => a.isActive && a.cif.WB_PRDGRP_ID > 0),
            (b) => b.cif.WB_PRDGRP_ID
        )

        if (_.isEmpty(pblshModelRow) || !pblshModelRow?.isActive) {
            ErrorMessage_restate(
                mp,
                true,
                'Not Set',
                `Published Model (${scnPlanRow.cif.WB_PUBLISHED_MODEL_ID}) not found`
            )
            return
        }

        scnPlnrRow.cif.WB_PUBLISHED_MODEL_ID = pblshModelRow.cif.WB_PUBLISHED_MODEL_ID
        scnPlnrRow.WB_PublishedModelRow = pblshModelRow

        if (_.isEmpty(scnPlnr.PERIODPART_START_DT) && _.isEmpty(scnPlnr.PERIODPART_END_DT)) {
            scnPlnrRow.StartDt = scnPlanRow.StartDt
            scnPlnrRow.EndDt = scnPlanRow.EndDt
        }

        // Load Customer, Products
        await self.CustomerProducts_checkPublishedModelComponents()

        this._scenarioCustomers = <WB_CustomerRow[]>(
            _.filter(self.AllCustomers, (a) => _.includes(wbCustIds, a.cif.WB_CUST_ID))
        )
        this._scenarioProductGroups = <WB_ProductGroupRow[]>(
            _.filter(self.AllProductGroups, (a) => _.includes(wbPrdGrpIds, a.cif.WB_PRDGRP_ID))
        )
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Scope operations">

    private _onScopeLockChange: BehaviorSubject<void>
    private _scopeMessages: MessageProvider
    private _scopeProgress: ProgressProvider

    private IScenarioPlanner_Scope_init() {
        //--
        this._onScopeLockChange = new BehaviorSubject<void>(undefined)
        this._scopeMessages = new MessageProvider()
        this._scopeProgress = new ProgressProvider()
    }

    get OnScopeLockChanged(): BehaviorSubject<void> {
        return this._onScopeLockChange
    }

    get ScopeMessages(): MessageProvider {
        return this._scopeMessages
    }

    get ScopeProgress(): ProgressProvider {
        return this._scopeProgress
    }

    get bScopeLocked(): boolean {
        return this.WB_ScenarioPlanner.bLocked
    }

    set bScopeLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }

    async unlockScope(): Promise<void> {
        //

        this.WB_ScenarioPlanner.bLocked = false
        this._onScopeLockChange.next()
    }

    async validateAndLockScope(): Promise<void> {
        let mp = this._scopeMessages
        let pp = this._scopeProgress
        pp.start()
        mp.clearMessages()

        // Validate selections

        ErrorMessage_restate(mp, !this.bScenarioLocked, 'Not Set', 'Scenario Plan not locked')

        ErrorMessage_restate(
            mp,
            !(this.WB_ScenarioPlanner.cif.WB_MODEL_EVTTYPER_ID > 0),
            'EvtTypeNotSet',
            'Event Type not set'
        )

        ErrorMessage_restate(mp, !this.Customers.length, 'NoCusts', 'No Customers Selected')

        ErrorMessage_restate(mp, !this.ProductGroups.length, 'NoProducts', 'No Products Selected')

        ErrorMessage_restate(mp, !_.isDate(this.WB_ScenarioPlanner.StartDt), 'StartDtInvalid', 'Start Date is not set')

        ErrorMessage_restate(mp, !_.isDate(this.WB_ScenarioPlanner.EndDt), 'EndDtInvalid', 'End Date is not set')

        ErrorMessage_restate(
            mp,
            !DateUtils.isLessThanEqual(this.WB_ScenarioPlanner.StartDt, this.WB_ScenarioPlanner.EndDt),
            'InvalidDate',
            'Invalid Date Range'
        )

        if (mp.countMessages(MessageType.Error) > 0) {
            pp.finish()
            return
        }

        this.WB_ScenarioPlanner.bLocked = true
        this._onScopeLockChange.next()
        pp.finish()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Product/Period/SubType Partition operations">

    private _onProductPartitionsChange: BehaviorSubject<void>
    private _onPeriodPartitionsChanged: BehaviorSubject<void>
    private _qsPeriodPartitions_sync: ExecutionSerializer
    private _allPeriods: WB_PeriodRow[]
    private _partitionPeriods: WB_PeriodRow[]
    private _wbPeriodHId_Loaded: boolean

    private _onEvtSubTypeChange: BehaviorSubject<void>

    private IScenarioPlanner_Partitions_init() {
        //--
        this._onProductPartitionsChange = new BehaviorSubject<void>(undefined)
        this._onPeriodPartitionsChanged = new BehaviorSubject<void>(undefined)
        this._allPeriods = []
        this._partitionPeriods = []
        this._wbPeriodHId_Loaded = false
        this._qsPeriodPartitions_sync = new ExecutionSerializer(
            this,
            this._periodPartitionSync.bind(this),
            [{}],
            250,
            false
        )
        this._onEvtSubTypeChange = new BehaviorSubject<void>(undefined)
    }

    private async IScenarioPlanner_Partitions_onLoadComplete(): Promise<void> {
        const self = this

        self.WB_ScenarioPlanner.setupOnChangeEvents(
            ['PERIODPART_START_DT', 'PERIODPART_END_DT', 'PERIODPART_DURATION'],
            () => {
                self.PeriodPartitionSync()
            }
        )
    }

    get OnProductPartitionsChanged(): BehaviorSubject<void> {
        return this._onProductPartitionsChange
    }

    get OnPeriodPartitionsChanged(): BehaviorSubject<void> {
        return this._onPeriodPartitionsChanged
    }

    get OnEventSubTypesChanged(): BehaviorSubject<void> {
        return this._onEvtSubTypeChange
    }

    async addPartition(sName: string): Promise<WB_ScenarioPlannerProductPartitionRow> {
        const self = this

        const newRow = <WB_ScenarioPlannerProductPartitionRow>(
            await self.dbContext.createRecordWithKey(esWB_ScnPlannerPrdPR)
        )
        newRow.setDefaults()
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.PRODUCT_PARTITION_NAME = sName
        self.dbContext.add(esWB_ScnPlannerPrdPR, newRow)
        self.OnProductPartitionsChanged.next()
        return newRow
    }

    async removePartition(wbScnPlannerPrdPRId: number): Promise<void> {
        const self = this
        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows, (ppr) => {
            if (!ppr.isActive) return

            if (ppr.cif.WB_SCNPLANNERPRDPR_ID == wbScnPlannerPrdPRId) {
                _.forEach(ppr.WB_ScenarioPlannerProductPartitionRelRows, (r) => {
                    if (r.isActive) r.markDeleted()
                })
                ppr.markDeleted()
            }
        })
        self.OnProductPartitionsChanged.next()
    }

    async addPartitionProductGroup(
        wbScnPlannerPrdPRId: number,
        wbPrdGrpId: number
    ): Promise<WB_ScenarioPlannerProductPartitionRelRow> {
        const self = this

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId)
        if (_.isEmpty(pg)) return undefined

        for (let ppr of self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows) {
            if (!ppr.isActive) continue

            if (ppr.cif.WB_SCNPLANNERPRDPR_ID != wbScnPlannerPrdPRId) continue

            for (let prdr of ppr.WB_ScenarioPlannerProductPartitionRelRows) {
                if (!prdr.isActive) continue

                if (prdr.cif.WB_PRDGRP_ID == wbPrdGrpId) return prdr
            }

            // Not found, create record
            const newRow = <WB_ScenarioPlannerProductPartitionRelRow>(
                await self.dbContext.createRecordWithKey(esWB_ScnPlannerPrdPPR)
            )
            newRow.cif.WB_SCNPLANNERPRDPR_ID = ppr.cif.WB_SCNPLANNERPRDPR_ID
            newRow.WB_ScenarioPlannerProductPartitionRow = ppr
            newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
            newRow.WB_ProductGroupRow = pg
            self.dbContext.add(esWB_ScnPlannerPrdPPR, newRow)
            self.OnProductPartitionsChanged.next()
            return newRow
        }
        return undefined
    }

    async removePartitionProductGroup(wbScnPlannerPrdPPRId: number): Promise<void> {
        const self = this

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows, (ppr) => {
            if (!ppr.isActive) return

            _.forEach(ppr.WB_ScenarioPlannerProductPartitionRelRows, (r) => {
                if (!r.isActive) return

                if (r.cif.WB_SCNPLANNERPRDPPR_ID == wbScnPlannerPrdPPRId) r.markDeleted()
            })
        })
        self.OnProductPartitionsChanged.next()
    }

    get PeriodPartitions(): WB_ScenarioPlannerPeriodPartitionRow[] {
        return _.filter(this.WB_ScenarioPlanner.WB_ScenarioPlannerPeriodPartitionRows, (a) => a.isActive)
    }

    PeriodPartitionSync(): void {
        // Debounce calls ...
        console.log('Synchronizing Periods: qsRun')
        this._qsPeriodPartitions_sync.Run({})
    }

    async _periodPartitionSync(): Promise<void> {
        const self = this

        try {
            //
            const duration = self.WB_ScenarioPlanner.cif.PERIODPART_DURATION
            const wbScnPlanId = self.WB_ScenarioPlanner.cif.WB_SCNPLAN_ID
            if (!(wbScnPlanId > 0)) return

            let scnPlanRow = await self.dbContext.find(esWB_ScnPlan, wbScnPlanId)
            if (!scnPlanRow?.isActive) return

            if (!(duration > 0)) return

            const wbPeriodHId = scnPlanRow.cif.WB_PERIODH_ID
            let startDt = self.WB_ScenarioPlanner.StartDt
            let endDt = self.WB_ScenarioPlanner.EndDt
            let pm = self.WB_ScenarioPlanner.WB_PublishedModelRow

            if (_.isEmpty(pm)) pm = scnPlanRow.WB_PublishedModelRow

            if (_.isEmpty(pm)) return

            const wbEntityIdPeriod = pm.cif.WB_ENTITY_ID_PERIOD
            const PubMdlStartDt = pm.EffectiveStartDt
            const PubMdlEndDt = pm.EffectiveEndDt
            startDt = DateUtils.Greatest(DateUtils.Least(startDt, PubMdlEndDt), PubMdlStartDt)
            endDt = DateUtils.Greatest(DateUtils.Least(endDt, PubMdlEndDt), PubMdlStartDt)

            if (self._wbPeriodHId_Loaded != wbPeriodHId) {
                self._wbPeriodHId_Loaded = wbPeriodHId
                const vSearchSchema = PASearch.createSimpleSchema([], ['WB_PERIODH_ID', 'WB_ENTITY_ID', 'WB_ENTITY_ID'])
                const arrPeriodSearchRows = await PASearch.find(
                    'vUI_Period_Hierarchy_Entity_Search',
                    {
                        where: {
                            WB_PERIODH_ID: wbPeriodHId,
                            WB_ENTITY_ID: wbEntityIdPeriod
                        }
                    },
                    vSearchSchema,
                    [],
                    0,
                    ['WB_PERIOD_ID']
                )
                const arrWbPeriodIds = <number[]>_.map(arrPeriodSearchRows, (row) => row.WB_PERIOD_ID)
                let allPeriods = <WB_PeriodRow[]>await self.dbContext.findUsingCache(esWB_Period, arrWbPeriodIds)

                allPeriods = _.sortBy(allPeriods, (a) => a.cif.PERIOD_START_DT)
                this._allPeriods = allPeriods
            }

            let periods: WB_PeriodRow[] = []
            if (DateUtils.isLessThanEqual(startDt, endDt)) {
                periods = _.filter(this._allPeriods, (p) =>
                    DateUtils.RangeDatesOverlap(startDt, endDt, p.PeriodStartDt, p.PeriodEndDt)
                )
                this._partitionPeriods = periods

                // Create Period Partitions
                let dctPeriodsByPartId: { [partId: number]: WB_PeriodRow[] } = {}
                let dctPartsMissing: { [partId: number]: number } = {}
                let partId = 0
                _.forEach(periods, (p, idx) => {
                    if (idx % duration == 0) partId++
                    if (partId in dctPeriodsByPartId) dctPeriodsByPartId[partId].push(p)
                    else dctPeriodsByPartId[partId] = [p]

                    dctPartsMissing[partId] = partId
                })

                let dctPartsExisting: { [partId: number]: number } = {}
                // Update Existing
                _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerPeriodPartitionRows, (pp) => {
                    if (!pp.isActive) return
                    let partId = pp.cif.PERIOD_PARTITION_ID
                    if (!(partId in dctPeriodsByPartId)) {
                        pp.markDeleted()
                        return
                    }
                    if (partId in dctPartsExisting) {
                        pp.markDeleted()
                        return
                    }
                    dctPartsExisting[partId] = partId
                    delete dctPartsMissing[partId]

                    let arrPeriods = dctPeriodsByPartId[partId]
                    let fp = _.first(arrPeriods)
                    let lp = _.last(arrPeriods)
                    pp.cif.START_DT = fp.cif.PERIOD_START_DT
                    pp.cif.END_DT = lp.cif.PERIOD_END_DT
                    pp.cif.WB_PERIOD_ID_CSV = _.join(
                        _.map(arrPeriods, (p) => p.cif.WB_PERIOD_ID),
                        ','
                    )
                })

                // Create Missing
                for (let partId of _.values(dctPartsMissing)) {
                    let arrPeriods = dctPeriodsByPartId[partId]
                    let fp = _.first(arrPeriods)
                    let lp = _.last(arrPeriods)
                    let newPart = <WB_ScenarioPlannerPeriodPartitionRow>(
                        await self.dbContext.createRecordWithKey(esWB_ScnPlannerPPR)
                    )
                    newPart.cif.PERIOD_PARTITION_ID = partId
                    newPart.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
                    newPart.cif.START_DT = fp.cif.PERIOD_START_DT
                    newPart.cif.END_DT = lp.cif.PERIOD_END_DT
                    newPart.cif.WB_PERIOD_ID_CSV = _.join(
                        _.map(arrPeriods, (p) => p.cif.WB_PERIOD_ID),
                        ','
                    )
                    self.dbContext.add(esWB_ScnPlannerPPR, newPart)
                }
            } else {
                // Don't change anything, avoid deleting stuff when dates invalid
            }

            self._onPeriodPartitionsChanged.next()
            // Update record to trigger other
            self.WB_ScenarioPlanner.emit(
                'change:PERIODPART_SYNC',
                self.WB_ScenarioPlanner,
                self.WB_ScenarioPlanner.cif.PERIODPART_DURATION
            )
        } catch (err) {
            console.log('Error in Sync: ', err)
            //pp.exception(err)
            //ExceptionMessage_restate(mp, err)
            throw err
        }
    }

    async addEventSubType(): Promise<WB_ScenarioPlannerEventTypeRow> {
        const self = this
        //--

        const newRow = <WB_ScenarioPlannerEventTypeRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerESR)
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        self.dbContext.add(esWB_ScnPlannerESR, newRow)
        self.OnEventSubTypesChanged.next()

        return newRow
    }

    async removeEventSubType(wbScnPlannerESRId: number): Promise<void> {
        const self = this

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerEventTypeRows, (est) => {
            if (!est.isActive) return
            if (est.cif.WB_SCNPLANNERESR_ID == wbScnPlannerESRId) {
                est.markDeleted()
            }
        })

        self.OnEventSubTypesChanged.next()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Constraint operations">

    private _onConstraintsChanged: BehaviorSubject<void>

    private IScenarioPlanner_Constraints_init() {
        //--
        this._onConstraintsChanged = new BehaviorSubject<void>(undefined)
    }

    get OnConstraintsChanged(): BehaviorSubject<void> {
        return this._onConstraintsChanged
    }

    async addConstraint(wbScnConstraintMId: number): Promise<WB_ScenarioPlannerConstraintRow> {
        const self = this

        const cnst = <WB_ScenarioConstraintRow>await self.dbContext.find(esWB_ScnConstraint, wbScnConstraintMId)
        if (_.isEmpty(cnst)) return undefined

        // Not found, create record
        const newRow = <WB_ScenarioPlannerConstraintRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerCnstr)
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.WB_SCNCONSTRAINTM_ID = wbScnConstraintMId
        newRow.WB_ScenarioConstraintRow = cnst
        self.dbContext.add(esWB_ScnPlannerCnstr, newRow)
        self.OnConstraintsChanged.next()
        return newRow
    }

    async removeConstraint(wbScnPlannerCnstRId: number): Promise<void> {
        const self = this

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerConstraintRows, (cnstr) => {
            if (!cnstr.isActive) return
            if (cnstr.cif.WB_SCNPLANNERCNSTR_ID == wbScnPlannerCnstRId) {
                cnstr.markDeleted()
            }
        })

        self.OnConstraintsChanged.next()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Available Promotion operations">

    private _onAvailablePromotionsChanged: BehaviorSubject<void>
    private _onAvailablePromotionPropertyChanged: BehaviorSubject<IAvailablePromotionEvent>

    private IScenarioPlanner_AvailablePromotions_init() {
        //--
        this._onAvailablePromotionsChanged = new BehaviorSubject<void>(undefined)
        this._onAvailablePromotionPropertyChanged = new BehaviorSubject(undefined)
    }

    get OnAvailablePromotionsChanged(): BehaviorSubject<void> {
        return this._onAvailablePromotionsChanged
    }

    get OnAvailablePromotionPropertyChanged(): BehaviorSubject<IAvailablePromotionEvent> {
        return this._onAvailablePromotionPropertyChanged
    }

    private async IScenarioPlanner_AvailablePromotions_onLoadComplete(): Promise<void> {
        const self = this

        // Register events
        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerPromotionRelRows, (pr) => {
            if (!pr.isActive) return

            pr.setupOnChangeEvents(['SUBTYPE_CODE'], self.IAvailablePromotions_onRecordChange.bind(self), self)
        })
    }

    private IAvailablePromotions_onRecordChange(
        record: WB_ScenarioPlannerPromotionRelRow,
        propertyName: string,
        propertyValue: any,
        options: ScenarioPlannerBO
    ) {
        this.OnAvailablePromotionPropertyChanged.next({
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    async addPrdPartitionCBO(
        wbPrdPartitionId: number,
        wbModelProfileId: number,
        options?: { sName?: string }
    ): Promise<{ rel: WB_ScenarioPlannerPromotionRelRow; cbo: ConstraintBasedOptimizerBO }> {
        const self = this
        const opts = options || {}

        let prdP = _.first(
            _.filter(
                self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows,
                (a) => a.cif.WB_SCNPLANNERPRDPR_ID == wbPrdPartitionId
            )
        )

        if (_.isEmpty(prdP) || !prdP?.isActive) return undefined

        // Create CBO BO
        let boOpts: ICBOCreateLoadOptions = {
            dbContext: self.dbContext,
            sName: opts.sName || self.WB_ScenarioPlanner.cif.PLANNER_NAME,
            wbMasterDataSetId: self.WB_ScenarioPlanner.cif.WB_MDSET_ID,
            wbSalesOrgId: self.WB_ScenarioPlanner.cif.WB_SALESORG_ID,
            wbPublishedModelId: self.WB_ScenarioPlanner.cif.WB_PUBLISHED_MODEL_ID,
            wbModelProfileId: wbModelProfileId,
            bScenarioPlannerInd: true,
            wbScnPlanId: self.WB_ScenarioPlanner.cif.WB_SCNPLAN_ID,
            wbScnPlannerId: self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID,
            wbScnPlannerPrdPrId: wbPrdPartitionId,
            customerRows: self.Customers, // optimization scope
            wbCustHId: self.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_CUSTH_ID_DS,
            wbPrdHId: self.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_PRDH_ID_DS,
            wbPeriodHId: self.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_PERIODH_ID_DS
        }

        let cbo = new ConstraintBasedOptimizerBO(boOpts)
        await cbo.LoadNew(boOpts)

        await cbo.Save()

        // Not found, create record
        const newRow = <WB_ScenarioPlannerPromotionRelRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerPrmR)
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.WB_SCNPLANNERPRDPR_ID = prdP.cif.WB_SCNPLANNERPRDPR_ID
        newRow.WB_ScenarioPlannerProductPartitionRow = prdP
        newRow.cif.WB_CBO_ID = cbo.WB_CBO.cif.WB_CBO_ID
        newRow.WB_CBORow = cbo.WB_CBO
        self.dbContext.add(esWB_ScnPlannerPrmR, newRow)
        await self.dbContext.Save(esWB_ScnPlannerPrmR, [newRow])

        newRow.setupOnChangeEvents(['SUBTYPE_CODE'], self.IAvailablePromotions_onRecordChange.bind(self), self)

        self.OnAvailablePromotionsChanged.next()
        return { rel: newRow, cbo: cbo }
    }

    async removePrdPartitionCBO(wbScnPlannerPrmRId: number): Promise<void> {
        const self = this

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerPromotionRelRows, (rel) => {
            if (!rel.isActive) return
            if (rel.cif.WB_SCNPLANNERPRMR_ID == wbScnPlannerPrmRId) {
                rel.markDeleted()
            }
        })

        self.OnAvailablePromotionsChanged.next()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Trials/ Rapid Planner">

    private IScenarioPlanner_Trial_init() {}

    private async IScenarioPlanner_Trial_onLoadComplete(): Promise<void> {
        const self = this

        if (_.isEmpty(self.WB_ScenarioPlanner.WB_ScenarioPlannerTrialRow)) {
            // create missing rapid planner row
            let rpTrial = <WB_ScenarioPlannerTrialRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerTrial)
            rpTrial.cif.KEEP_IND = '1'
            rpTrial.cif.TRIAL_TYPE = 'Rapid'
            self.dbContext.add(esWB_ScnPlannerTrial, rpTrial)
            self.WB_ScenarioPlanner.cif.WB_SCNPLANNERTRIAL_ID_RAPID = rpTrial.cif.WB_SCNPLANNERTRIAL_ID
            self.WB_ScenarioPlanner.WB_ScenarioPlannerTrialRow = rpTrial
        }
    }

    async addTrialCstPrdPeriod(
        trial: WB_ScenarioPlannerTrialRow,
        wbCustId: number,
        wbPrdPartId: number,
        periodPartId: number
    ): Promise<WB_ScenarioPlannerTrialPRRow> {
        const self = this

        if (_.isEmpty(trial)) return undefined

        let newRow = <WB_ScenarioPlannerTrialPRRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerTrialPR, {})
        newRow.setDefaults()
        newRow.cif.WB_SCNPLANNERTRIAL_ID = trial.cif.WB_SCNPLANNERTRIAL_ID
        newRow.WB_ScenarioPlannerTrialRow = trial
        newRow.cif.WB_CUST_ID = wbCustId
        newRow.cif.WB_SCNPLANNERPRDPR_ID = wbPrdPartId
        newRow.cif.PERIOD_PARTITION_ID = periodPartId
        newRow.cif.SUBTYPE_CODE = ''
        newRow.cif.PROMOTED_IND = '0'
        self.dbContext.add(esWB_ScnPlannerTrialPR, newRow)

        return newRow
    }

    //</editor-fold>

    //<editor-fold desc = "Reload operations">

    private _onReload: BehaviorSubject<void>

    Reload_init(): void {
        this._onReload = new BehaviorSubject<void>(undefined)
    }

    get OnReload(): BehaviorSubject<void> {
        return this._onReload
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Scope operations">

    private _onTrialStructureLockChange: BehaviorSubject<void>
    private _trialStructureMessages: MessageProvider
    private _trialStructureProgress: ProgressProvider

    private IScenarioPlanner_TrialStructure_init() {
        //--
        this._onTrialStructureLockChange = new BehaviorSubject<void>(undefined)
        this._trialStructureMessages = new MessageProvider()
        this._trialStructureProgress = new ProgressProvider()
    }

    get OnTrialStructureLockChanged(): BehaviorSubject<void> {
        return this._onTrialStructureLockChange
    }

    get TrialStructureMessages(): MessageProvider {
        return this._scopeMessages
    }

    get TrialStructureProgress(): ProgressProvider {
        return this._scopeProgress
    }

    get bTrialStructureLocked(): boolean {
        return this.WB_ScenarioPlanner.bTrialStructureLocked
    }

    set bTrialStructureLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }

    async unlockTrialStructure(): Promise<void> {
        //

        this.WB_ScenarioPlanner.bTrialStructureLocked = false
        this._onTrialStructureLockChange.next()
    }

    async validateAndLockTrialStructure(): Promise<void> {
        let mp = this._trialStructureMessages
        let pp = this._trialStructureProgress
        pp.start()
        mp.clearMessages()

        // Validate selections

        //--

        this.WB_ScenarioPlanner.bTrialStructureLocked = true
        this._onTrialStructureLockChange.next()
        pp.finish()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Flow Setup">
    private async IScenarioPlanner_Flow_onLoadComplete(): Promise<void> {
        const self = this

        if(_.isEmpty(self.WB_ScenarioPlanner.WB_AutomationFlowRow)){
            let flowRow = <WB_AutomationFlowRow> await self.dbContext.createRecordWithKey(esWB_Automation_Flow)
            let fl = flowRow.cif
            fl.SOURCE_TYPE = 'ScnPlanner'
            fl.SOURCE_WB_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
            fl.WB_MDSET_ID = self.WB_ScenarioPlanner.cif.WB_MDSET_ID
            fl.EMBEDDED_IND = '1'
            fl.MODULE_ID = 'ScnPlanner'
            let newFlow = FlowEditorUtils.createEmptyFlow()
            FlowEditorUtils.addDomainContext(newFlow, 'ScenarioPlannerSolver')
            flowRow.Flow = newFlow
            self.dbContext.add(esWB_Automation_Flow, flowRow)

            // setup Relation
            self.WB_ScenarioPlanner.cif.WB_AUTOMATION_FLOW_ID = fl.WB_AUTOMATION_FLOW_ID
            self.WB_ScenarioPlanner.WB_AutomationFlowRow = flowRow

        }

    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        const opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext
        } else {
            dbContext = new PAdbContext({})
        }
        const scope_options: CreateOptions = {
            standardConditions: {
                [esWB_ScnPlanner]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerCR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerPR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerCnstr]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerPPR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerPrdPR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerPrdPPR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerESR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerTrial]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerTrialCNR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerTrialPR]: { DELETED_IND: { notIn: ['1'] } },
                [esWB_ScnPlannerTrialEvt]: { DELETED_IND: { notIn: ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Published_Model]: [esWB_Entity, esWB_Model],
                [esWB_ScnPlannerTrial]: [esWB_ScnPlannerTrialPR, esWB_ScnPlannerTrialCNR]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_ScnPlanner]: [esWB_ScnPlannerCalc, esWB_ScnPlannerTrial, esWB_ScnPlannerTrialEvt]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, scope_options)

        return aRecResolver
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_ScnPlanner, ids)
                .then((result) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10
    }

    //</editor-fold>
};

PAEnvironment.registerBusinessObjectClass(ScenarioPlannerBO, "ScenarioPlannerBO", "Scenario Planner")
